import CheckBox from "../../UI/CheckBox/CheckBox";
import { ReactComponent as ArrowDownIcon } from "../../assets/icons/arrow_down.svg";
import "./ServiceList.css";
import { useContext, useEffect, useRef, useState } from "react";
import { category } from "../../state_management/actionTypes";
import { Link } from "react-router-dom";
import { getServiceLink } from "../../utilities/misc";
import { LocaleContext } from "../../AppProvider";

const ServiceList = ({ categories }: { categories: category[] }) => {
  const { t, locale } = useContext(LocaleContext);
  const listRef = useRef<HTMLDivElement>(null);
  const [showList, setShowList] = useState(false);

  const serviceCategory = useCategories().categories;

  useEffect(() => {
    const outSideClick = (e: MouseEvent) => {
      if (listRef.current && !listRef.current.contains(e.target as Node)) {
        setShowList(false);
      }
    };

    document.addEventListener(`click`, outSideClick);

    return () => {
      document.removeEventListener(`click`, outSideClick);
    };
  }, []);

  const newCategoryIdArray = (category: category): number[] => {
    const isAvailable = serviceCategory.indexOf(category.id) >= 0;

    const array = isAvailable
      ? serviceCategory.filter((item) => item !== category.id)
      : [...serviceCategory, category.id];

    return Array.from(new Set(array));
  };

  const service_link = getServiceLink(locale);

  return (
    <div className="service_list_wrapper">
      <span
        onClick={(e) => {
          e.stopPropagation();
          setShowList(!showList);
        }}
      >
        <p className="med_text">{t("What areas shall we clean?")}</p>
        <ArrowDownIcon />
      </span>
      <div ref={listRef} className={`service_list ${showList ? `` : `hide`}`}>
        {categories ? (
          categories
            .sort((a, b) => (a.position || 0) - (b.position || 0))
            .map((category, n) => (
              <Link
                to={{
                  pathname: `/${service_link}`,
                  search: newCategoryIdArray(category).length
                    ? "?" +
                      new URLSearchParams({
                        category: newCategoryIdArray(category)
                          .map((item) => `${item}`)
                          .toString()
                      }).toString()
                    : undefined
                }}
                key={n}
                className="service_item_wrap center"
              >
                <CheckBox checked={serviceCategory.indexOf(category.id) >= 0} />
                <span>{category.name}</span>
              </Link>
            ))
        ) : (
          <div></div>
        )}
      </div>
    </div>
  );
};

export default ServiceList;

export const useCategories = () => {
  const [categories, setCategories] = useState<{ categories: number[] }>({
    categories: []
  });
  const path = window.location.href;

  useEffect(() => {
    try {
      const myURL = new URL(path);
      const catIdArray: number[] = [];
      myURL.searchParams.forEach((value, name) => {
        if (name === "category") {
          catIdArray.push(
            ...value
              .split(",")
              .filter((id) => parseInt(id))
              .map((item) => parseInt(item))
          );
        }
      });
      setCategories({ categories: [...catIdArray] });
    } catch (err) {
      setCategories({
        categories: []
      });
    }
  }, [path]);

  return { ...categories };
};
